export const PERMS = {
    READ: 'report_dispatcher_kpi.read',
    EXPORT: 'report_dispatcher_kpi.export',
}
